export default __webpack_public_path__ + "static/media/logo.7abf39fe.png";